import { writable, get } from 'svelte/store';
export const createSelectedSortingStore = () => {
    const sortingStore = { name: 'Date', value: 'createdAt' };
    const selectedSortingStore = writable(sortingStore);
    const setSelectedSorting = (sorting) => {
        selectedSortingStore.set(sorting);
        console.log('Store', sorting);
    };
    const getSelectedSorting = () => get(selectedSortingStore);
    return {
        subscribe: selectedSortingStore.subscribe,
        setSelectedSorting,
        getSelectedSorting,
    };
};
